import { useState, useEffect } from 'react';
import { Download } from 'lucide-react';
import Layout from '../components/layout/Layout';
import Header from '../components/layout/Header';
import MonthPicker from '../components/payments/MonthPicker';
import PaymentSummaryCards from '../components/payments/PaymentSummaryCards';
import PaymentRankings from '../components/payments/PaymentRankings';
import PaymentTrendChart from '../components/payments/PaymentTrendChart';
import PaymentTable from '../components/payments/PaymentTable';
import { usePaymentMonths } from '../hooks/usePayments';
import api from '../lib/api';

/** 직전 월 'YYYY-MM' (KST) */
function defaultYm(): string {
    const now = new Date(Date.now() + 9 * 3600 * 1000);
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1));
    const p = (n: number) => String(n).padStart(2, '0');
    return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}`;
}

export default function PaymentDashboardPage() {
    const [ym, setYm] = useState(defaultYm());
    const { data: months } = usePaymentMonths();

    // 집계된 월이 있으면 기본값을 최신 월로 보정
    useEffect(() => {
        if (months && months.length > 0 && !months.includes(ym)) {
            setYm(months[0]);
        }
    }, [months]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleExport = async () => {
        try {
            const res = await api.get('/payments/export', { params: { ym }, responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `결제내역_${ym}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch {
            console.error('엑셀 내보내기 실패');
        }
    };

    return (
        <Layout>
            <Header
                title="결제 정보"
                subtitle="단지별 월간 결제 금액 및 추이"
                actions={
                    <>
                        <MonthPicker value={ym} onChange={setYm} />
                        <button
                            onClick={handleExport}
                            className="inline-flex items-center gap-1.5 px-3.5 py-2 text-xs font-medium text-white bg-[#1ABB9C] rounded hover:bg-[#169F85] transition"
                        >
                            <Download className="w-3.5 h-3.5" />
                            엑셀 내보내기
                        </button>
                    </>
                }
            />
            <div className="px-6 py-6">
                <PaymentSummaryCards ym={ym} />
                <PaymentRankings ym={ym} />
                <PaymentTrendChart />
                <PaymentTable ym={ym} />
            </div>
        </Layout>
    );
}
